import { PatientParms } from "../shared";
import { Patient } from "../registeration/patients";
import { EmrTaps } from "./emr-taps/emr-taps.service";
import { CafTempData } from "./emr-caf/emr-caf-template.service";
import { DoctorNurseNotes } from "./doctor-nurse-notes/doctor-nurse-notes.service";
import { EnumServiceType } from "../enumeration/enum-service-type";
import { Data } from "@angular/router";

// Clinical Notes Intefaces
export interface EmrClinicalOrders {
  serial: number;
  emrNonCodedEntriesStpSerial?: number;
  visitSerial?: number;
  orderAsText: string;
  notesOnOrder: string;
  startDate: Date;
  endDate: Date;
  expectedStartTime: Date;
  expectedEndTime: Date;
  status?: number;
  plannedDate: Date;
  priority?: number;
  toothNo?: number;
  dentalStatus?: string;
  dentalPlannedType?: number;
  serviceId: number;
  orderType?: number;
  dataStatus?: number;
  deleteStatus?: number;
  orderDescEn?: string;
  orderDescAr?: string;
  regDate?: any;
  userID?: number;
  userName?: number;
  intervention: string;
  orderPrice: number;
}
export interface EmrClinicalNotes {
  serial: number;
  emrNonCodedEntriesStpSerial?: number;
  visitSerial?: number;
  notes: string;
  notesType: number;
  dataStatus?: number;
  deleteStatus?: number;
  orderDescEn?: string;
  orderDescAr?: string;
  regDate?: any;
  userID?: number;
  userName?: number;
}
export interface EmrConsultation {
  serial: number;
  visitSerial?: number;
  forwardTo?: number;
  forwardingType?: number;
  notes?: string;
  consultationReason;
  status?: number;
  dataStatus?: number;
  deleteStatus?: number;
  regDate?: number;
  plannedDate?: Date;
}
export interface EmrClinicalForm {
  serial?: number;
  visitSerial?: number;
  jsonObject?: string;
  formKey?: number;
}
export interface VehicalForm {
  serial?: number;
  jsonObject?: string;
  formKey?: number;
}

// Vitals Interfaces
export interface EmrBodyInOutMaterials {
  serial: number;
  emrNonCodedEntriesStpSerial?: number;
  quantity?: number;
  timeCode: number;
  quantityUnit?: string;
  visitSerial?: number;
  notes: string;
  startDate: Date;
  endDate: Date;
  startTime: string;
  expectedStartTime: Date;
  expectedEndTime: Date;
  status?: number;
  inOutFlag?: number;
  dataStatus?: number;
  root: string;
  userID?: number;
  userName?: number;
  amPm?: string
}
export interface EmrPatVitals {
  bp?: string;
  bP2?: string;
  spo2?: string;
  codeBlueFlag?: number
  vitalSource?: number;
  vitalSourceSerial?: number;
  dataStatus?: number
  time?: string
  serial?: number;
  visitSerial?: number;
  visitsList?: string;
  entryDate?: any;
  entryDate1?: any;
  temperature?: number;
  pulse?: number;
  bloodGroupAr?: string
  highPressure?: number;
  lowPressure?: number;
  respiratory?: number;
  pressureRate?: number;
  patientCode?: number;
  selectAllVisit?: number;
  sat?: number;
  weight?: number;
  height?: number;
  headCircumference?: number;
  headCircumferenceNotes?: number;
  bloodSuger?: number;
  deleteStatus?: number;
  pulseNotes?: string;
  pressureNotes?: string;
  temperatureNotes?: string;
  satNotes?: string;
  bloodSugerNotes?: string;
  respiratoryNotes?: string;
  heightNotes?: string;
  weightNotes?: string;
  userID?: number;
  userName?: string;
  regDate?: any;
  notes?: string;
  cvp?: number;
  cvpNote?: string;
  inspired?: number;
  inspiredNotes?: string;
  abdominalCircumference?: number;
  abdominalCircumferenceNotes?: string;
  tabCode?: number;
  serialSheet?: number;
  incubatorNumber?: number;
  incubatorNumberNotes?: string;
  incubatorDate?: number;
  incubatorDateNotes?: string;
  incubatorTemperature?: number;
  incubatorTemperatureNotes?: string;
  monitorNumber?: number;
  monitorNumberNotes?: string;
  bloodCulture?: number;
  bloodCultureNotes?: string;
  durationIllness?: string;
  lmp?: string;
  emrCodeBlueDocumentationSerial?: number

}

// Emr Three Main Intrfaces
export interface EmrPatDiagnosis {
  serial: number;
  visitSerial: number;
  diagSerial?: number;
  diagCode?: number;
  status?: number;
  notes?: string;
  deleteStatus?: number;
  protectionLevel?: number;
  description?: string;
  statusAr?: string;
  statusEn?: string;
  userName?: string;
  regPatServiceSerial?: number;
  nphiesDiagnosisType?: number;
  nphiesDiagnosisTypeAr?: string;
  nphiesDiagnosisTypeEn?: string;
  userID?: number;
  docId?: number;
  regDate?: any;
  diagnosisDesc?: string;
  daignoisCode?: number;
  diagnosDate?: Date;
  nphiesConditionOnset?: string
  nphiesConditionOnsetCode?: number
  dexter_SinisterFlag_Right: number;
  dexter_SinisterFlag_Left: number;
}
export interface EmrPatComplains {
  serial: number;
  visitSerial: number;
  medCompainSerial: number;
  onSet?: string;
  course: string;
  duration: string;
  sheetData?: string;
  deleteStatus?: number;
  regSecLoginId?: number;
  notes?: string;
  protectionLevel: number;
  complaintDescAr?: string;
  regPatServiceSerial?: number;
  complaintDescEn?: string;
  userName?: string;
  userID?: number;
  docId?: number;
  regDate?: any;
  dexter_SinisterFlag_Right: number;
  dexter_SinisterFlag_Left: number;
  complainDesc?: string;
  nphiesSnomedCode?: string;
  nphiesSnomedDisplay?: string;
  nphiesSnomedSerial?: string;

}
export interface EmrPatFinding {
  serial: number;
  visitSerial: number;
  findSerial: number;
  findCode?: number;

  status: number;
  notes: string;
  deleteStatus?: number;
  protectionLevel: number;
  description?: string;
  statusAr?: string;
  statusEn?: string;
  userName?: string;
  userID?: number;
  docId?: number;
  regDate?: any;
  findDesc?: string;
  regPatServiceSerial?: number;
  dexter_SinisterFlag: number;
  findingDesc?: string;
  findingDescEn?: string;
}

// Emr Medical Scores
export interface EmrPatGlasgowComaScale {
  serial?: number;
  visitSerial?: number;
  bestEyeResponse?: number;
  bestMotorResponse?: number;
  bestVerbalResponse?: number;
  result?: number;
  deleteStatus?: number;
  bestEyeText?: string;
  bestMotorText?: string;
  bestVerbalText?: string;
  userName?: string;
  userID?: number;
  regDate: Date;
  dataStatus?: number;
  actualDate: Date;
}
export interface EmrPatBehavioralPainScale {
  serial?: number;
  visitSerial?: number;
  facialExpression?: number;
  upperLimbMovements?: number;
  compMechVent?: number;
  result?: number;
  deleteStatus?: number;
  facialExpressionText?: string;
  upperLimbMovementsText?: string;
  compMechVentText?: string;
  userName?: string;
  userID?: number;
  regDate?: Date;
  actualDate?: Date;
  tabCode: number;
  serialSheet: number;
}
export interface EmrPatNonverbalPainScale {
  serial?: number;
  visitSerial?: number;
  face?: number;
  activity?: number;
  guarding?: number;
  legs?: number;
  consolability?: number;
  cry?: number;
  physiology?: number;
  respiratory?: number;
  result?: number;
  deleteStatus?: number;
  faceText?: string;
  activityText?: string;
  guardingText?: string;
  physiologyText?: string;
  respiratoryText?: string;
  userName?: string;
  userID?: number;
  regDate?: any;
  tabCode?: number;
  serialSheet?: number;
  editFlag?: boolean
}

// Emr Glass Card Interface
export interface EmrPatGlassCard {
  serial: number;
  visitSerial: number;
  type: number;
  os: string;
  od: string;
  disOsSph: string;
  disOsCyl: string;
  disOsAx: string;
  disOdSph: string;
  disOdCyl: string;
  disOdAx: string;
  disPd: string;
  nearOsSph: string;
  nearOsCyl: string;
  nearOsAx: string;
  nearOdSph: string;
  nearOdCyl: string;
  nearOdAx: string;
  nearPd: string;
  deleteStatus: number;
  userName?: string;
  userID?: number;
  patCode?: number;
  cCCallBeneficiaryCode?: number;
  regDate?: Date;
  bcvaod: number;
  bcvaos: number;
  status: number;
  addOd: number;
  addOs: number;
}

// Emr History Interface
export interface EmrPatHistory {
  serial: number;
  visitSerial: number;
  historycode: any;
  historyText: string;
  type: number;
  startDate: Date;
  endDate: Date;
  notes: string;
  family: number;
  past: number;
  serviceCode: number;
  drugMaterialCode: number;
  drugMaterialText: string;
  drugDosageCode: number;
  drugDostageText: string;
  drugFrequancyCode: number;
  drugFrequancyText: string;
  deleteStatus: number;
  userName?: string;
  userID?: number;
  historyTypeEn?: string;
  historyTypeAr?: string;
  nameEn?: string;
  nameAr?: string;
  dexter_SinisterFlag_Right: number;
  dexter_SinisterFlag_Left: number;
  dexterSinisterFlag: number
  purpose: string;
  dataStatus?: number;
}

// Emr Allergy Interface
export interface EmrPatAllergy {
  serial: number;
  visitSerial: number;
  category: number;
  substanceCode: number;
  substanceText: string;
  reaction: number;
  severity: number;
  infoSource: number;
  notes: string;
  deleteStatus: number;
  categoryNameAr?: string;
  categoryNameEn?: string;
  drugNameAr?: string;
  drugNameEn?: string;
  patCode?: number;
  noAllergy?: number;
  noAllergyByUser?: string;
  noAllergyRegDate?: Date;

}

// filter in patient interfaces
export interface InPatientFilter {
  patientCode?: number;
  residenceDegree?: number;
  contractId?: number;
  floorId?: number;
  roomId?: number;
  bedId?: number;
  docCode?: number;
  searchClosedVisits?: number;
  fromDate?: Date;
  fastSearchData?: string;
}
export interface OutPatientFilter {
  patientCode?: number;
  datetime?: number;
  fastSearchData?: string;
  steps?: any;
  examinationState?: number;
  examinationDone?: any;
  waiting?: any;
  clinicId?: number;
  companyCode?: number;
  docCode: number;
}
export interface ErPatientFilter {
  patientCode?: number;
  contractId?: number;
  workStatus?: number;
  fromDate?: Date;
  toDate?: Date;
  fastSearchData?: string;
}
export interface AnyPatientFilter {
  serviceCode?: number;
  patCode?: number;
  specialityId?: number;
  docId?: number;
  status?: number;
  payed?: number;
  fromDate?: Date;
  toDate?: Date;
  fastSearchData?: string;
}

// patient blood types intrface
export interface PatientBloodTypeData {
  code: number;
  bloodGroup: number;
  rhValue: number;
}

// Emr Patient Parms Interface
export interface EmrPatientParms extends PatientParms {
  flag?: number;
  serviceType?: number;
  specialityCode?: number;
  userId?: number;
  resourceType?: number;
  userTabs?: string;
  episoidVisits?: string;
  filterByVisitsList?: number;
  filterByEpisoidVisits?: number;
  docNurseMode?: number;
  patLookupList?: number;
  fixedProfileTag?: string;
  getDocFavoriteList?: number;
  tabCode?: number
}

// Emr Panner Data Interface
export interface PannerData extends Patient {
  patientCode?: number;
  gender_name_ar?: string;
  gender_name_en?: string;
  ageYears?: number;
  visitsList?: any;
  levelOneNameAr?: string
  isLastMonthContractEndDate?: number
  cardEndDate?: Date
  contractEndDate?: Date
  levelOneNameEn?: string
  patientCustomCode?: string;
  countryFlag?: string;
  nationalityAr?: string;
  nationalityEn?: string;
  chronic?: number;
  allergy?: number;
  docNameAr?: string;
  docNameEn?: string;
  patientAge?: number;
  patientAgeMonths?: number;
  patientAgeDays?: number;
  visitSerial?: number;
  socialId?: number;
  socialCode?: number;
  infection?: number;
  visitNo?: number;
  socialNameAr?: string;
  socialNameEn?: string;
  allergyTooltip?: string;
  chronicTooltip?: string;
  infectionTooltip?: string;
  isPregnancy?: boolean;

  altAddressAr?: string;
  altAddressEn?: string;
}

// Emr Lab &  Rad Interface
export interface ILabRad {
  nameAr?: string;
  nameEr?: string;
  startDate?: Date;
  abnormality?: any;
  labTestResult?: any;
  serviceNameAr?: string;
  serviceNameEn?: string;
  expectedStartTime?: any;
  serviceStatusAr?: string;
  serviceStatusEn?: string;
  serviceStatusCode?: number;
  docNameAr?: string;
  docNameEn?: string;
  htmlContent?: string;
  regPatServiceSerial?: number;
  dicomUrl?: string;
  reportStatus?: number;
}

// Emr Medication Data Interface
export interface Medication {
  nameAr?: string;
  nameEn?: string;
  docNameAr?: string;
  docNameEn?: string;
  startDate?: Date;
  rxDescAr?: string;
  rxDescEn?: string;
  visitSerial?: number
}

// Most Importnant Intrface In Emr Data
export interface IMedicalData {
  PannerData: PannerData;
  Vitals: EmrPatVitals;
  MatrixVitals: EmrPatVitals[];
  History: EmrPatHistory[];
  Complain: EmrPatComplains[];
  emrProblemLists: any[];
  emrTreatmentRecord: any[];
  Diagnois: EmrPatDiagnosis[];
  Rad: ILabRad[];
  Lab: ILabRad[];
  Medication: Medication[];
  Allergy: EmrPatAllergy[];
  Findings: EmrPatFinding[];
  GlassCards: EmrPatGlassCard[];
  EmrBurnChart: EmrBurnChart[];
  GlasgowComaScale: EmrPatGlasgowComaScale[];
  BehavioralPainScale: EmrPatBehavioralPainScale[];
  NonverbalPainScale: EmrPatNonverbalPainScale[];
  FacePainRatingScale: EmrFacePainRatingScale[];
  EmrClinicalOrders: EmrClinicalOrders[];
  EmrClinicalNotes: EmrClinicalNotes[];
  EmrConsultation: EmrConsultation[];
  EmrTabs: any[];
  EmrTabsInnerData: any[];
  DoctorNurseNotes: DoctorNurseNotes[];

  labResult: any[];
  labResult1: any[];
  labResult2: any[];
  labResult3: any[];
  RadResults: any[];
  emrPatientTimelineList: any[];
  NonScheduledDoses: any[];
  cafData: CafTempData[];
  operationData: IOperationData[];
  emrHTMLReports: IEmrHTMLReports[];
}

// Patient List Loookup
export const PatListLookup = {
  ...EnumServiceType,
};

export interface IOperationData {
  regPatServiceSerial: number;
  serviceId: number;
  servStatus: number;
  expectedStartTime: Date;
  startDate: Date;
  serviceNameAr: string;
  serviceNameEn: string;
  serviceType: number;
  statusNameAr: string;
  statusNameEn: string;
  staffData: IOperationStaff[];
}

export interface IOperationStaff {
  serial: number;
  visitSerial: number;
  empId: number;
  medRoleCode: number;
  regPatServiceSerial: string;
  regPatServiceSerialAr: string;
  regPatServiceSerialEn: string;
  empNameAr: string;
  empNameEn: string;
  medRoleAr: string;
  medRoleEn: string;
}

export const Sys_Days: {
  code: number;
  nameAr: string;
  nameEn: string;
  sysNo: number;
}[] = [
    { code: 1, nameAr: "الأحد", nameEn: "Sunday", sysNo: 0 },
    { code: 2, nameAr: "الإثنين", nameEn: "Monday", sysNo: 1 },
    { code: 3, nameAr: "الثلاثاء", nameEn: "Tuesday", sysNo: 2 },
    { code: 4, nameAr: "الأربعاء", nameEn: "Wednesday", sysNo: 3 },
    { code: 5, nameAr: "الخميس", nameEn: "Thursday", sysNo: 4 },
    { code: 6, nameAr: "الجمعة", nameEn: "Friday", sysNo: 5 },
    { code: 7, nameAr: "السبت", nameEn: "Saturday", sysNo: 6 },
  ];

export interface ISchedulingObj {
  startDate: Date;
  hour: number;
  days: string;
  freqType: number;
  freqQty: number;
  periodQty: number;
  periodType: number;
  quantity: number;
  scheduleType: number;
}

export interface IEmrHTMLReports {
  serial: number;
  visitSerial: number;
  patCode: number;
  regPatServiceSerial: number;
  reportType: number;
  htmlContent: string;
  signedBy: number;
  emrHtmlTemplatesSerial: number;
  nameAr?: string;
  nameEn?: string;
}

export interface EmrFacePainRatingScale {
  serial: number;
  visitSerial: number;
  bodyPart: string;
  score: number;
  measureTime: any;
  notes: string;
  deleteStatus: number;
  regDate?: Date;
  patientExpresses: number;
  character: number;
  frequency: string;
  radiation: string;
  intervention: string;
  medicationIntervention: string;
  tabCode?: number;
  serialSheet?: number;
  bodies?: any
  editFlag?: boolean
  numericalScale?: number;
  predlsposingFactors?: string;
  painWorse?: string;
  painBetter?: string;
  duration?: string;
  painRating?: string;
  painLocationText?: string;

}

export interface EmrBurnChart {
  serial: number;
  score: number;
  visitSerial: number;
  timeOfBurn: any;
  dateOfBurn: Date;
  notes: string;
  bodypart: string;
  burnPercent: number;
  causesOfBurn: number;
  firstAidAtSiteBurn: string;
  deleteStatus: number;
  patientExpresses: number;
}

export enum EmrProfileTags {
  dentist = "DENTIST",
  eyes = "EYES",
  obstetrics = "OBSTETRICS",
  physical_therapy = "PHYSICALTHERAPY",
  dermatology = "DERMATOLOGY",
  therapeutic_feeding = "THERAPEUTICFEEDING",
}
